<template>
  <app-layout :subtitle="$t('uploadFilesManager.subtitle')">
    <upload-password v-if="$store.state.password === null" @submit-password="submitPassword">
      <error-popup :message="$store.state.errors.password" v-if="$store.state.errors.password" />
    </upload-password>

    <div v-if="$store.state.password !== null">
      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-3">
          <p style="font-weight: bold;">{{ $t('uploadFilesManager.sender.part1') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ this.sender }}</span> {{ $t('uploadFilesManager.sender.part2') }}</p>
        </div>
      </div>
      <files-card
          :description="description"
          :servletUrl="servletUrl"
          :show-comment-field="true"
          :url="$route.params.id">
        <span class="toolbar__text" slot="toolbar-text">
          {{ $t('uploadFilesManager.toolbarText') }} <span :class="!$store.state.isHkom ? 'text-primary' : 'text-primary--green'">{{ this.date }}</span></span>
      </files-card>

      <step-publish
          :button-text="buttonText"
          :is-button-disabled="!canPublish"
          :class-object="{'card-white': true}"
          :post-url="postUrl"
          :redirect-url="redirectUrl"
          :emit-custom="true"
          @publish-custom="publishCustom">
      </step-publish>
    </div>
  </app-layout>
</template>

<script>
import FilesCard from '../files/FilesCard'
import StepPublish from '../step/StepPublish'
import AppLayout from '../layout/AppLayout'
import UploadPassword from './UploadPassword'
import ErrorPopup from '../ui/ErrorPopup'

export default {
  name: "UploadFilesManager",
  components: {
    FilesCard,
    AppLayout,
    StepPublish,
    UploadPassword,
    ErrorPopup,
  },
  data() {
    return {
      buttonText: this.$t('uploadFilesManager.buttonText'),
      postUrl: "/public/api/receive/" + this.$route.params.id + "/add",
      redirectUrl: "/vsebina/nalozeno-povezava",
      servletUrl: '/ReceiverUploadServlet',
      description: null,
      date: null,
      sender: null,
      error: null,
      showPasswordModal: true,
      state: this.$store.state,
    }
  },
  methods: {
    submitPassword(value) {
      this.$http.get('/public/api/receive/' + this.$route.params.id, {
        credentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-SOVD-Packet-Password": value,
        }
      }).then(response => {
        if (response.body.error) {
          this.error = response.body.error
          this.$store.setErrors({
            password: this.$t('errors.wrongPassword')
          })
        } else {
          this.$store.resetError("password")
          this.$store.setPassword(value)
          this.sender = response.body.owner
          this.date = response.body.validTo
          this.description = response.body.description
          this.showPasswordModal = false
        }
      }, response => {
        if (response.status === 404) {
          this.error = response.body.error
          this.$store.setErrors({
            password: this.$t('errors.invalidPackage')
          })
        }
      })
    },
    publishCustom() {
      var ids = []
      var names = []

      for (var i = 0; i < this.$store.state.files.length; i++) {
          ids.push(this.$store.state.files[i].id)
          names.push(this.$store.state.files[i].name)
      }

      var packet = {
        ids: ids,
        imena: names,
        url: this.$route.params.id,
        comment: this.$store.state.comment,
      }

      this.$http.post(this.postUrl, packet, {
        credentials: true
      }).then(response => {
        if (response.bodyText !== "{}") {
          this.$store.setErrors(response.body)
        } else {
          this.$router.push(this.redirectUrl)
        }
      }, response => {
        // error
      })
    }
  },
  computed: {
    canPublish() {
      let finishedUploading = this.$store.state.files.some(file => file.percent !== 100)
      return !finishedUploading && this.$store.state.files.length
    }
  },
  destroyed() {
    // this.$store.resetStore()
  }
}
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/upload-files/UploadFilesManager.vue